import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect, useCallback } from 'react';

const navItems = [
  { label: '首页', path: '/' },
  { label: '电视剧大全', path: '/category/all' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 50);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 group"
          >
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg transition-transform group-hover:scale-110">
              <i className="ri-movie-2-line text-background-50 text-lg"></i>
            </div>
            <span className={`font-heading text-xl font-bold transition-colors ${
              scrolled ? 'text-foreground-900' : 'text-white'
            }`}>
              天美影视
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => {
              const isActive = item.path === '/'
                ? location.pathname === '/'
                : location.pathname.startsWith(item.path);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all whitespace-nowrap ${
                    isActive
                      ? scrolled
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-white/20 text-white'
                      : scrolled
                        ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200'
                        : 'text-white/80 hover:text-white hover:bg-white/10'
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              onClick={() => navigate('/category/all')}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                scrolled
                  ? 'bg-background-200 text-foreground-700 hover:bg-background-300'
                  : 'bg-white/15 text-white hover:bg-white/25'
              }`}
            >
              <i className="ri-search-line text-base"></i>
              <span>搜索剧集</span>
            </button>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              scrolled ? 'text-foreground-900 hover:bg-background-200' : 'text-white hover:bg-white/10'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200 py-3 px-2 -mx-4">
            {navItems.map((item) => {
              const isActive = item.path === '/'
                ? location.pathname === '/'
                : location.pathname.startsWith(item.path);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`block px-4 py-3 rounded-lg text-sm font-medium transition-all ${
                    isActive
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
            <button
              onClick={() => {
                setMobileOpen(false);
                navigate('/category/all');
              }}
              className="w-full mt-2 px-4 py-3 rounded-lg text-sm font-medium bg-background-100 text-foreground-700 hover:bg-background-200 transition-all text-left"
            >
              <i className="ri-search-line mr-2"></i>搜索剧集
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}